import { h } from "./../../utils/createElement";
import { __extends } from "tslib";
import * as React from 'react';
import ReactDOM from 'react-dom';
import classNames from 'classnames';
import { decideKeepDom } from '../../utils/keepDom';
export var TOAST_TRANSITION_DURATION = 200;
var Toast = (function (_super) {
    __extends(Toast, _super);
    function Toast() {
        return _super !== null && _super.apply(this, arguments) || this;
    }
    Toast.prototype.componentDidMount = function () {
        console.warn('PC端Toast组件不符合交互规则，为避免破坏性更新，当前版本仍将提供。未来会移除此组件，请尽量使用Snackbar组件。');
    };
    Toast.prototype.render = function () {
        var _a, _b;
        var _c = this.props, prefixCls = _c.prefixCls, className = _c.className, style = _c.style, children = _c.children, content = _c.content, visible = _c.visible, mask = _c.mask, position = _c.position;
        var cls = classNames(prefixCls, className, prefixCls + "-" + position, (_a = {},
            _a[prefixCls + "-hidden"] = !visible,
            _a));
        var maskCls = classNames(prefixCls + "-mask", (_b = {},
            _b[prefixCls + "-mask-display"] = mask,
            _b[prefixCls + "-mask-hidden"] = !visible,
            _b));
        if (!decideKeepDom.call(this, TOAST_TRANSITION_DURATION, visible)) {
            return null;
        }
        return ReactDOM.createPortal(h("div", { className: maskCls },
            h("div", { className: cls, style: style }, children || content)), document.body);
    };
    return Toast;
}(React.Component));
export default Toast;
Toast.defaultProps = {
    prefixCls: 'dui-toast',
    visible: false,
    content: '',
    mask: false,
    position: 'top'
};
